import { defineStore } from 'pinia'

import {
  type BudgetEntriesListParameters,
  type BudgetEntryPagination,
  type PageNumberPaginationParameters,
  listBudgetEntries,
  listBudgets,
  retrieveBudget,
} from '@/api'
import type { PageNumberPagination, UUID } from '@/types'
import type { Budget, BudgetEntry, BudgetLight } from '@/types/budget'

interface State {
  budgets: { [id: UUID]: BudgetLight | Budget }
  budgetPage: PageNumberPagination<UUID> | null
  entries: { [entryId: UUID]: BudgetEntry }
  entryPage: BudgetEntryPagination<UUID> | null
}

export const useBudgetStore = defineStore('budget', {
  state: (): State => ({
    budgets: {},
    budgetPage: null,
    entries: {},
    entryPage: null,
  }),
  actions: {
    async list(params: PageNumberPaginationParameters) {
      const response = await listBudgets(params)
      this.budgets = {
        ...this.budgets,
        ...Object.fromEntries(response.results.map((budget) => [budget.id, budget])),
      }
      this.budgetPage = {
        ...response,
        results: response.results.map(({ id }) => id),
      }
    },

    async get(budgetId: UUID) {
      const budget = await retrieveBudget(budgetId)
      this.budgets = {
        ...this.budgets,
        [budget.id]: budget,
      }
    },

    async listEntries(budgetId: UUID, params: BudgetEntriesListParameters) {
      const response = await listBudgetEntries(budgetId, params)
      this.entries = {
        ...this.entries,
        ...Object.fromEntries(response.results.map((budgetEntry) => [budgetEntry.id, budgetEntry])),
      }
      this.entryPage = {
        ...response,
        results: response.results.map(({ id }) => id),
      }
    },
  },
})
